// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1iA-f","label":"Completed_label__3Dxpo"};